import { useState, Fragment } from "react";
import { ViewListingDescriptionWrapper, ViewListingDescriptionText, ViewListingReadMoreButton } from "../viewListingStyling";
import useIsDesktopSize from "../../../hook/useIsDesktopSize";
import ViewListingDescriptionPopup from "../popups/viewListingDescriptionPopup";

export default function ViewListingDescription({ description }: { description: string }) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const isDesktopSize = useIsDesktopSize();

    const formatTextWithLineBreaks = (text: string) => {
        const lines = text.split("\n");
        return lines.map((line, index) => {
            if (index === lines.length - 1) {
                return (
                    <Fragment key={index}>
                        {line}
                        {(isDesktopSize ? description.length > 400 : description.length > 200) && (
                            <>
                                {"... "}
                                <ViewListingReadMoreButton type="button" onClick={() => setIsPopupOpen(true)}>
                                    Read more
                                </ViewListingReadMoreButton>
                            </>
                        )}
                    </Fragment>
                );
            }
            return (
                <Fragment key={index}>
                    {line}
                    <br />
                </Fragment>
            );
        });
    };

    const truncatedDescription = isDesktopSize
        ? description.length > 400
            ? description.slice(0, 400)
            : description
        : description.length > 200
        ? description.slice(0, 200)
        : description;

    return (
        <>
            <ViewListingDescriptionWrapper>
                {description !== "" && description !== null && (
                    <ViewListingDescriptionText>
                        {formatTextWithLineBreaks(truncatedDescription)}
                    </ViewListingDescriptionText>
                )}
            </ViewListingDescriptionWrapper>
            <ViewListingDescriptionPopup
                description={description}
                toggleSelected={() => setIsPopupOpen(false)}
                selected={isPopupOpen}
            />
        </>
    );
}
